import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import BtnSecondaryS from "../Buttons/BtnSecondaryS";
import PropTypes from "prop-types";

const Headline = ({
  headline,
  description,
  center = false,
  buttonCTA,
  onClickLink,
  type,
  disabled,
  className, // add className prop
}) => {
  return (
    <div
      className={`flex flex-row w-full gap-2 ${center ? "justify-center items-center text-center" : "justify-between items-start text-left"}`}
    >
      <div
        className={`flex flex-col gap-1 w-full md:w-auto ${center ? "items-center" : "items-start"}`}
      >
        <div className={`grid grid-cols-5 w-full md:items-start items-center md:flex md:flex-col md:gap-2 ${className || ""}`}>
          <h1 className={`text-2xl onmd:text-3xl font-bold col-span-3 ${center ? 'text-center w-full' : ''}`}>{headline}</h1>
        </div>
        <p className={`text-base hidden md:block ${center ? 'text-center w-full' : ''}`}>{description}</p>
      </div>
      {buttonCTA && (
        <>
          {/* Mobile: Small Button */}
          <div className="self-start md:self-center md:hidden flex items-start">
            <BtnSecondaryS
              buttonCTA={buttonCTA}
              onClickLink={onClickLink}
              type={type}
              disabled={disabled}
            />
          </div>
          {/* Desktop: Medium Button */}
          <div className="self-center hidden md:block">
            <BtnSecondaryM
              buttonCTA={buttonCTA}
              onClickLink={onClickLink}
              type={type}
              disabled={disabled}
            />
          </div>
        </>
      )}
    </div>
  );
};

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  center: PropTypes.bool,
  buttonCTA: PropTypes.string,
  onClickLink: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.elementType,
  className: PropTypes.string, // add prop type
};

export default Headline;
